import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import riwayatPengajuanService from "../../services/riwayatPengajuanService";
import Cookies from "js-cookie";

export const initialState = {
    loading_riwayat_pengajuan: false,
    data_riwayat_pengajuan: [],
    showMessage:false,
    message:'',
}


export const getDataRiwayatPengajuan = createAsyncThunk('project/data',async (data, { rejectWithValue }) => {
    try {
        const response = await riwayatPengajuanService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const riwayatPengajuanSlice = createSlice({
    name: 'riwayat_pengajuan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_riwayat_pengajuan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataRiwayatPengajuan.fulfilled, (state, action) => {
                state.loading_riwayat_pengajuan = false
                state.data_riwayat_pengajuan = action.payload??[]
            })
            .addCase(getDataRiwayatPengajuan.pending, (state) => {
                state.loading_riwayat_pengajuan = true
            })
            .addCase(getDataRiwayatPengajuan.rejected, (state, action) => {
                state.loading_riwayat_pengajuan = false
                state.data_riwayat_pengajuan = action.payload
            })
    },
})

export const {
    showLoading,
} = riwayatPengajuanSlice.actions

export default riwayatPengajuanSlice.reducer
